import { PalletTypesFormProps } from 'interfaces';
import { translate } from 'utils/translate';

export const palletTypesFormValidation = [
   ({ availablePalletTypes }: PalletTypesFormProps) => {
      if (availablePalletTypes.length === 0) {
         return {
            availablePalletTypes: translate('sendPalletsModal.errors.chooseAtLeastOnePalletType'),
         };
      }
   },
];
